<div [ngClass]="{ 'banner-component': true, 'bg-home': applyHomeStyle() }">
  @if (isBreadcrumbVisible()) {
    <div class="breadcrumb-container">
      <breadcrumb-component
        [items]="breadcrumbs() | translation: 'content' | async"
      />
    </div>
  }

  <div class="titles-buttons-container">
    <div class="titles-container">
      <h1 class="banner-title">
        {{ title() | translate: { id: titleBannerId() } }}
      </h1>
      @if (subtitle()) {
        <h2 class="banner-subtitle">{{ subtitle() | translate }}</h2>
      }
    </div>
    <div class="buttons-container">
      @if (ctaButtons()) {
        <div class="buttons-container">
          @for (button of ctaButtons(); track button.customId) {
            <button-component
              [classNameButton]="button.classNameButton"
              [text]="button.text ?? '' | translate"
              [sizeButton]="button.sizeButton"
              [classNameIcon]="button.classNameIcon"
              [customId]="button.customId"
              [isSpinner]="button.isSpinner"
              [leftIcon]="button.leftIcon"
              [modeColorButton]="button.modeColorButton"
              [rightIconChevron]="button.rightIconChevron"
              [textAlternative]="button.textAlternative ?? '' | translate"
              [typeButton]="button.typeButton"
              (click)="button?.action()"
              [appButtonDisable]="isBannerButtonDisable()"
            />
          }
        </div>
      }
    </div>
  </div>
</div>
